import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import SchemaOrg from "@/components/base/SchemaOrg";

export default function About() {
  return (
    <>
      <SchemaOrg
        type="Organization"
        data={{
          name: "白丝足交完全指南",
          url: "https://baisi-guide.com",
          description: "深入解析白丝足交的感官魅力、技巧要点与互动体验，为成人伴侣提供专业、私密的参考内容。",
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <div className="pt-20 pb-12 px-6 md:px-10">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: "关于我们" },
              ]}
            />

            {/* Page Header */}
            <div className="mb-12">
              <h1 className="text-3xl md:text-5xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                关于我们
              </h1>
              <p className="text-base text-foreground-600 max-w-2xl leading-relaxed">
                白丝足交完全指南 —— 专注于为成人伴侣提供专业、私密的白丝足交感官体验与技巧参考内容。
              </p>
            </div>

            {/* Brand Introduction */}
            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-5" style={{ fontFamily: "var(--font-heading)" }}>
                品牌介绍
              </h2>
              <div className="bg-background-50 rounded-lg border border-background-200 p-6 md:p-8">
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  白丝足交完全指南成立于2024年，是国内领先的白丝足交专业内容平台。我们致力于为成人伴侣提供科学、健康、富有情趣的白丝足交指南，帮助每一位读者在安全、私密的前提下探索和提升感官体验。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  我们的内容团队由资深感官体验研究者、健康护理专家和内容创作者组成，每一篇文章都经过严谨的调研和撰写，确保信息的准确性和实用性。从白丝的材质选择到足部护理技巧，从互动姿势到情趣提升，我们覆盖了白丝足交的方方面面。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  我们相信，高质量的感官互动是健康亲密关系的重要组成部分。通过提供专业、私密的参考内容，我们希望帮助更多伴侣在信任和尊重的基础上，探索属于彼此的感官世界。
                </p>
              </div>
            </section>

            {/* Core Values */}
            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-5" style={{ fontFamily: "var(--font-heading)" }}>
                核心价值
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                <div className="bg-background-50 rounded-lg border border-background-200 p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-50">
                    <i className="ri-shield-check-line text-xl text-accent-500"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2">专业权威</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    每一篇内容都经过专业团队的调研和审校，确保信息准确、科学、实用。
                  </p>
                </div>
                <div className="bg-background-50 rounded-lg border border-background-200 p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-50">
                    <i className="ri-lock-line text-xl text-accent-500"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2">隐私至上</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    我们尊重每一位读者的隐私，网站无需注册即可访问全部内容，不收集任何个人信息。
                  </p>
                </div>
                <div className="bg-background-50 rounded-lg border border-background-200 p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-50">
                    <i className="ri-heart-line text-xl text-accent-500"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2">尊重包容</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    倡导健康、平等的亲密关系观念，鼓励伴侣之间开放沟通、相互尊重。
                  </p>
                </div>
              </div>
            </section>

            {/* Reputation & Trust */}
            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-5" style={{ fontFamily: "var(--font-heading)" }}>
                声誉与信任
              </h2>
              <div className="bg-background-50 rounded-lg border border-background-200 p-6 md:p-8">
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  自成立以来，白丝足交完全指南已累计服务超过50万读者，发布的文章被多家成人健康媒体转载和引用。我们始终坚持内容为王的原则，每一篇文章都经过至少三轮审核才能发布。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  我们与多位性健康专家、皮肤护理专家和心理咨询师保持合作，确保内容的科学性和专业性。同时，我们定期收集读者反馈，持续优化和更新内容，力求为读者提供最有价值的参考信息。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  我们承诺：所有内容均为原创，绝不抄袭或搬运他人作品。所有健康建议均经过专业审核，读者可以放心参考。
                </p>
              </div>
            </section>

            {/* Contact Information */}
            <section id="contact">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-5" style={{ fontFamily: "var(--font-heading)" }}>
                联系我们
              </h2>
              <div className="bg-background-50 rounded-lg border border-background-200 p-6 md:p-8">
                <p className="text-sm text-foreground-700 leading-relaxed mb-6">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们联系。我们通常会在24小时内回复。
                </p>
                <div className="space-y-4 mb-6">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-50 flex-shrink-0">
                      <i className="ri-mail-line text-accent-500"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">电子邮箱</p>
                      <p className="text-sm text-foreground-900">contact@baisi-guide.com</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-50 flex-shrink-0">
                      <i className="ri-time-line text-accent-500"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">工作时间</p>
                      <p className="text-sm text-foreground-900">周一至周五 9:00 - 18:00</p>
                    </div>
                  </div>
                </div>

                <form
                  id="contact-form"
                  data-readdy-form=""
                  className="space-y-4"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget as HTMLFormElement;
                    const formData = new FormData(form);

                    const honeypotEl = form.querySelector('[name="phone_alt"]') as HTMLInputElement;
                    if (honeypotEl && honeypotEl.value.trim() !== "") {
                      form.reset();
                      const statusEl = document.getElementById("form-status");
                      if (statusEl) {
                        statusEl.textContent = "消息已发送，我们将尽快回复！";
                        statusEl.className = "text-sm text-green-600 mt-3";
                      }
                      return;
                    }

                    try {
                      const response = await fetch("https://readdy.ai/api/form/d9q3cfue3oq4jqumtfqg", {
                        method: "POST",
                        headers: { "Content-Type": "application/x-www-form-urlencoded" },
                        body: new URLSearchParams(
                          Array.from(formData.entries())
                            .filter(([key]) => key !== "phone_alt")
                            .map(([k, v]) => [k, v.toString()])
                        ).toString(),
                      });

                      const responseText = await response.text();
                      let parsed;
                      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

                      const statusEl = document.getElementById("form-status");
                      if (response.ok && parsed?.code === "OK") {
                        form.reset();
                        if (statusEl) {
                          statusEl.textContent = "消息已发送，我们将尽快回复！";
                          statusEl.className = "text-sm text-green-600 mt-3";
                        }
                      } else {
                        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || "发送失败，请稍后重试";
                        if (statusEl) {
                          statusEl.textContent = serverMsg;
                          statusEl.className = "text-sm text-red-500 mt-3";
                        }
                      }
                    } catch {
                      const statusEl = document.getElementById("form-status");
                      if (statusEl) {
                        statusEl.textContent = "网络错误，请稍后重试";
                        statusEl.className = "text-sm text-red-500 mt-3";
                      }
                    }
                  }}
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-xs text-foreground-700 mb-1.5">姓名</label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-accent-300 transition-colors duration-200"
                        placeholder="您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-xs text-foreground-700 mb-1.5">邮箱</label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-accent-300 transition-colors duration-200"
                        placeholder="your@email.com"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="contact-subject" className="block text-xs text-foreground-700 mb-1.5">主题</label>
                    <input
                      id="contact-subject"
                      name="subject"
                      type="text"
                      required
                      className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-accent-300 transition-colors duration-200"
                      placeholder="请输入主题"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-xs text-foreground-700 mb-1.5">留言内容</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      rows={5}
                      maxLength={500}
                      required
                      className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-accent-300 transition-colors duration-200 resize-none"
                      placeholder="请输入您的留言（最多500字）"
                    ></textarea>
                    <p className="text-xs text-foreground-500 mt-1">最多500个字符</p>
                  </div>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="absolute opacity-0 pointer-events-none"
                    style={{ position: "absolute", left: "-9999px", top: "-9999px" }}
                  />
                  <button
                    type="submit"
                    className="px-6 py-2.5 bg-accent-500 text-background-50 rounded-md text-sm font-medium hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap"
                  >
                    发送消息
                  </button>
                  <div id="form-status"></div>
                </form>
              </div>
            </section>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}